import React, { useEffect, useState } from 'react';
interface TypingTextProps {
  text: string;
  speed?: number;
  delay?: number;
  className?: string;
}
const RANDOM_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
export function TypingText({
  text,
  speed = 50,
  delay = 0,
  className = ''
}: TypingTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [showCursor, setShowCursor] = useState(true);
  const [glitchIndex, setGlitchIndex] = useState(-1);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    let currentIndex = 0;
    let glitchCount = 0;
    const getRandomChar = () => RANDOM_CHARS[Math.floor(Math.random() * RANDOM_CHARS.length)];
    const startTyping = () => {
      if (currentIndex < text.length) {
        // Show glitch effect for current character (3-5 random chars before showing real char)
        if (glitchCount < 3) {
          const glitchedText = text.substring(0, currentIndex) + getRandomChar();
          setDisplayedText(glitchedText);
          setGlitchIndex(currentIndex);
          glitchCount++;
          timeout = setTimeout(startTyping, 30); // Faster glitch
        } else {
          // Show real character
          setDisplayedText(text.substring(0, currentIndex + 1));
          setGlitchIndex(-1);
          currentIndex++;
          glitchCount = 0;
          timeout = setTimeout(startTyping, speed);
        }
      } else {
        setIsComplete(true);
        setGlitchIndex(-1);
      }
    };
    // Start typing after delay
    timeout = setTimeout(startTyping, delay);
    return () => clearTimeout(timeout);
  }, [text, speed, delay]);
  // Blinking cursor effect
  useEffect(() => {
    if (!isComplete) return;
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530);
    return () => clearInterval(cursorInterval);
  }, [isComplete]);
  return <span className={`${className} font-mono`} data-id="element-181">
      {displayedText.split('').map((char, idx) => <span key={idx} className={`${idx === glitchIndex ? 'text-ai-teal animate-pulse' : 'text-muted-gold'} transition-colors duration-100`} data-id="element-182">
          {char}
        </span>)}
      <span className={`inline-block w-[3px] h-[1.2em] bg-ai-teal ml-1 align-middle ${showCursor ? 'opacity-100' : 'opacity-0'} transition-opacity duration-100 shadow-[0_0_8px_rgba(62,240,209,0.8)]`} aria-hidden="true" data-id="element-183" />
    </span>;
}